(function () {
  'use strict';

  var defaults = {
    email: 'mail@goettling.ae',
    emailSubject: '',
    whatsapp: '971562983731',
    whatsappText: '',
    phone: '',
    launcher: 'brand',
    color: '#000000',
    accent: '#111111',
    badge: '1',
    header: 'Get in touch',
    headerSub: "Email or WhatsApp. Choose how you'd like to contact us.",
    emailTitle: 'Email',
    emailSubtitle: 'mail@goettling.ae',
    whatsappTitle: 'WhatsApp',
    whatsappSubtitle: '+971 56 298 3731',
    callTitle: 'Call',
    callSubtitle: '+971 4 427 0568'
  };

  var cfg = {};

  function assignConfig() {
    var extra = window.CONTACT_WIDGET || {};
    var key;
    for (key in defaults) {
      cfg[key] = extra[key] != null && extra[key] !== '' ? extra[key] : defaults[key];
    }
    if (extra.email === '') cfg.email = '';
    if (extra.whatsapp === '') cfg.whatsapp = '';
    if (extra.phone === '') cfg.phone = '';
    if (extra.badge === '') cfg.badge = '';
    if (extra.emailSubject != null) cfg.emailSubject = extra.emailSubject;
    if (extra.whatsappSubtitle != null && extra.whatsappSubtitle !== '') cfg.whatsappSubtitle = extra.whatsappSubtitle;
    if (extra.headerSub != null && extra.headerSub !== '') cfg.headerSub = extra.headerSub;
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function digits(phone) {
    return String(phone || '').replace(/\D/g, '');
  }

  function mailHref() {
    var href = 'mailto:' + cfg.email;
    if (cfg.emailSubject) href += '?subject=' + encodeURIComponent(cfg.emailSubject);
    return href;
  }

  function attribCookie() {
    try {
      var match = document.cookie.match(/(?:^|; )goettling_attrib=([^;]*)/);
      if (!match) return null;
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (err) {
      return null;
    }
  }

  function writeAttribCookie(data) {
    try {
      document.cookie =
        'goettling_attrib=' +
        encodeURIComponent(JSON.stringify(data)) +
        '; Max-Age=' +
        90 * 24 * 60 * 60 +
        '; Path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (err) {}
  }

  function randomVid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var rand = (Math.random() * 16) | 0;
      var value = char === 'x' ? rand : (rand & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function paramsFromSearch() {
    var p = {};
    try {
      var sp = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = sp.get(k);
        if (v) p[k] = v;
      });
    } catch (err) {}
    return p;
  }

  function mergeUtmParams() {
    var data = attribCookie() || {};
    var attrib = window.GoettlingAttrib || {};
    var out = {};
    function add(src) {
      if (!src || typeof src !== 'object') return;
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        if (src[k] && !out[k]) out[k] = src[k];
      });
    }
    // Cookie first (first-touch), then GoettlingAttrib, then URL. Never let empty {} win.
    add(data.params);
    add(attrib.params);
    add(paramsFromSearch());
    return out;
  }

  function ensureAttrib() {
    var data = attribCookie() || {};
    var attrib = window.GoettlingAttrib || {};
    var vid = attrib.vid || data.vid || '';
    try {
      var urlVid = new URLSearchParams(window.location.search).get('vid');
      if (!vid && urlVid) vid = urlVid;
    } catch (err) {}
    var params = mergeUtmParams();
    var landing = attrib.entryUrl || data.entryUrl || window.location.href;
    var entryPath =
      attrib.entryPath || data.entryPath || window.location.pathname + window.location.search;
    var referrer = attrib.initialReferrer || data.initialReferrer || document.referrer || '';
    var dirty = false;

    if (!vid) {
      vid = randomVid();
      dirty = true;
    }
    if (!data.vid || data.vid !== vid) dirty = true;
    if (!data.entryUrl) dirty = true;
    if (!data.params || typeof data.params !== 'object') dirty = true;

    data.vid = vid;
    data.created = data.created || new Date().toISOString();
    data.params = Object.keys(data.params || {}).length
      ? (function () {
          var merged = {};
          var srcs = [data.params, params];
          srcs.forEach(function (src) {
            if (!src) return;
            Object.keys(src).forEach(function (k) {
              if (src[k] && !merged[k]) merged[k] = src[k];
            });
          });
          return merged;
        })()
      : params;
    data.entryUrl = data.entryUrl || landing;
    data.entryPath = data.entryPath || entryPath;
    if (!data.initialReferrer && referrer) data.initialReferrer = referrer;

    if (dirty) writeAttribCookie(data);
    return { vid: vid, params: data.params || params };
  }

  function buildWaText() {
    var a = ensureAttrib();
    var query = [];
    if (a.vid) query.push('vid=' + encodeURIComponent(a.vid));
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (a.params[k]) query.push(encodeURIComponent(k) + '=' + encodeURIComponent(a.params[k]));
    });
    return 'Hello, I came from https://goettling.ae/' + (query.length ? '?' + query.join('&') : '');
  }

  function waHref() {
    var phone = digits(cfg.whatsapp);
    var text = buildWaText();
    var url = 'https://api.whatsapp.com/send?phone=' + phone;
    if (text) url += '&text=' + encodeURIComponent(text);
    return url;
  }

  function stampWaHref() {
    var link = document.querySelector('#cw-host [data-cw-event="contact_widget_whatsapp"]');
    if (link) link.href = waHref();
  }

  function telHref() {
    return 'tel:+' + digits(cfg.phone);
  }

  function pushEvent(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var a = ensureAttrib();
      var payload = {
        event: name,
        visitor_id: a.vid || '',
        lead_source: (a.params && a.params.utm_source) || '',
        lead_medium: (a.params && a.params.utm_medium) || '',
        lead_campaign: (a.params && a.params.utm_campaign) || ''
      };
      if (extra) {
        var key;
        for (key in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
        }
      }
      window.dataLayer.push(payload);
    } catch (err) {}
  }

  function bubblePath(fill, dotFill) {
    return (
      '<path d="M43.7305 0C52.4763 0.000144748 58.3066 5.83121 58.3066 14.5771V32.0693C58.3066 40.8153 52.4764 46.6463 43.7305 46.6465H32.0684L19.0957 55.2754C17.1717 56.5872 14.5765 55.1885 14.5762 52.8564V46.6465C5.83026 46.6463 0 40.8153 0 32.0693V14.5771C4.04806e-05 5.83121 5.83029 0.000144741 14.5762 0H43.7305Z" fill="' +
      fill +
      '"/>' +
      '<circle cx="16.587" cy="23.5011" r="3.58704" fill="' +
      dotFill +
      '"/>' +
      '<circle cx="29.4991" cy="23.5011" r="3.58704" fill="' +
      dotFill +
      '"/>' +
      '<circle cx="42.4132" cy="23.5011" r="3.58704" fill="' +
      dotFill +
      '"/>'
    );
  }

  function launcherSvg() {
    return (
      '<svg class="cw-bubble" width="39" height="37" viewBox="0 0 59 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      bubblePath(esc(cfg.color), 'white') +
      '</svg>'
    );
  }

  function roundSvg() {
    return (
      '<svg class="cw-round-icon" width="21" height="20" viewBox="0 0 59 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      bubblePath('#fff', esc(cfg.accent)) +
      '</svg>'
    );
  }

  function closeSvg() {
    return (
      '<svg class="cw-x" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>' +
      '</svg>'
    );
  }

  function emailIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      '<path fill="#111" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/>' +
      '</svg>'
    );
  }

  function whatsappIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">' +
      '<path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>' +
      '</svg>'
    );
  }

  function callIcon() {
    return (
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
      '<path fill="#111" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>' +
      '</svg>'
    );
  }

  function isDesktop() {
    return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function copyText(text) {
    text = String(text || '');
    if (!text) return Promise.resolve(false);

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard
        .writeText(text)
        .then(function () {
          return true;
        })
        .catch(function () {
          return fallbackCopy(text);
        });
    }

    return Promise.resolve(fallbackCopy(text));
  }

  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (err) {
      return false;
    }
  }

  function card(href, iconClass, icon, title, subtitle, eventName, opts) {
    opts = opts || {};
    var attrs = '';
    if (opts.newTab) attrs += ' target="_blank" rel="noopener noreferrer"';
    if (opts.copyValue) attrs += ' data-cw-copy="' + esc(opts.copyValue) + '"';
    return (
      '<a class="cw-card" href="' +
      esc(href) +
      '"' +
      attrs +
      ' data-cw-event="' +
      esc(eventName) +
      '">' +
      '<span class="cw-icon ' +
      iconClass +
      '">' +
      icon +
      '</span>' +
      '<span class="cw-copy"><span class="cw-title">' +
      esc(title) +
      '</span><span class="cw-sub">' +
      esc(subtitle) +
      '</span></span>' +
      '</a>'
    );
  }

  function markup() {
    var cards = '';
    if (cfg.email) {
      cards += card(mailHref(), 'is-mail', emailIcon(), cfg.emailTitle, cfg.emailSubtitle, 'contact_widget_email');
    }
    if (cfg.whatsapp) {
      cards += card(
        waHref(),
        'is-wa',
        whatsappIcon(),
        cfg.whatsappTitle,
        cfg.whatsappSubtitle,
        'contact_widget_whatsapp',
        { newTab: true }
      );
    }
    if (cfg.phone) {
      cards += card(
        telHref(),
        'is-call',
        callIcon(),
        cfg.callTitle,
        cfg.callSubtitle,
        'contact_widget_call',
        { copyValue: cfg.callSubtitle }
      );
    }

    var isRound = cfg.launcher === 'round';
    var fabInner = isRound ? roundSvg() : launcherSvg();
    var badge = isRound && cfg.badge ? '<span class="cw-badge">' + esc(cfg.badge) + '</span>' : '';

    return (
      '<div class="cw-panel" role="dialog" aria-labelledby="cw-header-title">' +
      '<div class="cw-header">' +
      '<p class="cw-header-title" id="cw-header-title">' +
      esc(cfg.header) +
      '</p>' +
      (cfg.headerSub ? '<p class="cw-header-sub">' + esc(cfg.headerSub) + '</p>' : '') +
      '</div>' +
      '<div class="cw-body">' +
      cards +
      '</div>' +
      '</div>' +
      '<div class="cw-launcher">' +
      '<button type="button" class="cw-fab" aria-label="' +
      esc(cfg.header) +
      '" aria-expanded="false">' +
      fabInner +
      badge +
      '<span class="cw-close">' +
      closeSvg() +
      '</span>' +
      '</button>' +
      '</div>'
    );
  }

  var docClick;
  var docKey;

  function destroy() {
    if (docClick) document.removeEventListener('click', docClick);
    if (docKey) document.removeEventListener('keydown', docKey);
    docClick = null;
    docKey = null;
    var host = document.getElementById('cw-host');
    if (host && host.parentNode) host.parentNode.removeChild(host);
  }

  function mount() {
    try {
      if (document.getElementById('cw-host')) return;
      assignConfig();
      if (!cfg.email && !cfg.whatsapp && !cfg.phone) return;

      var host = document.createElement('div');
      host.id = 'cw-host';
      if (cfg.launcher === 'round') host.className = 'is-round';
      host.innerHTML = markup();
      document.documentElement.appendChild(host);

      var fab = host.querySelector('.cw-fab');
      var open = false;

      var setOpen = function (next) {
        open = next;
        if (open) host.className = (cfg.launcher === 'round' ? 'is-round ' : '') + 'is-open';
        else host.className = cfg.launcher === 'round' ? 'is-round' : '';
        fab.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          stampWaHref();
          pushEvent('contact_widget_open');
        }
      };

      fab.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(!open);
      });

      var links = host.querySelectorAll('[data-cw-event]');
      for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function (event) {
          var link = this;
          var copyValue = link.getAttribute('data-cw-copy');
          if (link.getAttribute('data-cw-event') === 'contact_widget_whatsapp') {
            link.href = waHref();
          }
          pushEvent(link.getAttribute('data-cw-event'), {
            link_url: link.getAttribute('href') || ''
          });

          if (copyValue && isDesktop()) {
            event.preventDefault();
            copyText(copyValue).then(function (ok) {
              var sub = link.querySelector('.cw-sub');
              if (ok && sub) {
                var original = sub.textContent;
                sub.textContent = 'Number copied';
                setTimeout(function () {
                  sub.textContent = original;
                }, 2000);
              }
            });
            return;
          }

          setTimeout(function () {
            setOpen(false);
          }, 400);
        });
      }

      docClick = function (event) {
        if (!open) return;
        if (host.contains(event.target)) return;
        setOpen(false);
      };
      docKey = function (event) {
        if (event.key === 'Escape' && open) setOpen(false);
      };
      document.addEventListener('click', docClick);
      document.addEventListener('keydown', docKey);
      stampWaHref();
    } catch (err) {}
  }

  window.ContactWidget = {
    mount: mount,
    destroy: destroy,
    remount: function (next) {
      if (next) {
        var extra = window.CONTACT_WIDGET || {};
        var merged = {};
        var key;
        for (key in extra) merged[key] = extra[key];
        for (key in next) merged[key] = next[key];
        window.CONTACT_WIDGET = merged;
      }
      destroy();
      mount();
    }
  };

  function boot() {
    mount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
